import { render } from "./videoDetails.vue?vue&type=template&id=aab7ed50&scoped=true"
import script from "./videoDetails.vue?vue&type=script&lang=js"
export * from "./videoDetails.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-aab7ed50"

export default script